import Banner from "./../assets/banner.png";

export default function MobilePaymentCard() {
  return <img src={Banner} className="125" />;
}
